import GenericModal from '../../generic/modal/GenericModal';
import ModalBody from '../../generic/modal/ModalBody';
import ModalFooter from '../../generic/modal/ModalFooter';
import ModalHeader from '../../generic/modal/ModalHeader';
import translations from '../../../translations';
import ButtonDefault from '../../buttons/ButtonDefault';
import ButtonPrimary from '../../buttons/ButtonPrimary';
import FileDrop from '../../generic/upload/FileDrop';
import useThemeImport from './useThemeImport';
import type { UserTenantResponseAPI } from '../../../types/user';
import { useState } from 'react';

type Props = {
    show: boolean;
    onClose: () => void;
    modalContainer: HTMLElement | null | undefined;
    tenant: UserTenantResponseAPI;
    onImportSuccess: () => void;
};

const ImportThemeModal = ({ show, onClose, modalContainer, tenant, onImportSuccess }: Props) => {
    const [isProcessing, setIsProcessing] = useState(false);

    const onImportComplete = () => {
        onImportSuccess();
        setIsProcessing(false);
        onClose();
    };

    const { showConfirmation, importMessage, onConfirmImport, onCancelImport, onDrop } =
        useThemeImport({ tenant, onImportSuccess: onImportComplete });

    const onDismissConfirmation = () => {
        onCancelImport();
        setIsProcessing(false);
        onClose();
    };

    const UI = showConfirmation ? 'confirmation' : 'form';

    const onConfirmImportModal = () => {
        setIsProcessing(true);
        onConfirmImport();
    };

    return (
        <GenericModal show={show} onHide={onDismissConfirmation} container={modalContainer}>
            {UI === 'form' && (
                <>
                    <ModalHeader onHide={onDismissConfirmation}>
                        <h4 className="modal-title">{translations.THEMES_import_heading}</h4>
                    </ModalHeader>
                    <ModalBody>
                        <FileDrop
                            onChange={onDrop}
                            placeholder={translations.THEMES_import_placeholder}
                            fileTypes=".thme"
                        />
                    </ModalBody>
                </>
            )}
            {UI === 'confirmation' && (
                <>
                    <ModalHeader onHide={onDismissConfirmation}>
                        {translations.IMPORT_confirm_title}
                    </ModalHeader>
                    <ModalBody>
                        <p>{importMessage}</p>
                    </ModalBody>
                    <ModalFooter>
                        <ButtonDefault onClick={onDismissConfirmation}>
                            {translations.COMMON_cancel}
                        </ButtonDefault>
                        <ButtonPrimary onClick={onConfirmImportModal} disabled={isProcessing}>
                            {translations.COMMON_confirm}
                        </ButtonPrimary>
                    </ModalFooter>
                </>
            )}
        </GenericModal>
    );
};
export default ImportThemeModal;
